module.exports = __webpack_public_path__ + "static/img/not-duty.eedffcc9.png";